import React, { useState } from 'react'
import Dropdown from '../Dropdown'
import {
    Container, NavWrapper, Link, Wrapper, SearchContainer,
    SelectOption, Search, Icon, Update, Header
} from './style'
import { header } from '../../mock/headerData';
import Image from '../../assets/imgs/header.png';

import { commonOptions4 } from '../../mock/dropdownData';

export default function SearchHeader() {
    const [search, setSearch] = useState('');
    const onChange = (e) => {
        setSearch({ search: e.target.value });
    }

    const onSearch = () => {
        console.log(search);
    }



    return (
        <Container>
            <NavWrapper top>
                {header.map((value) => {
                    return (
                        <Wrapper key={value.id}>
                            <Link>{value.chat}</Link>
                            <Link defaultColor>{value.phone}</Link>
                            <Link defaultColor >{value.email}</Link>
                        </Wrapper>
                    )
                })}

                {header.map((value) => {
                    return (
                        <Wrapper key={value.id}>
                            <Link>{value.blog}</Link>
                            <Link>{value.about}</Link>
                            <Link>{value.career}</Link>
                        </Wrapper>
                    )
                })}
            </NavWrapper>

            <NavWrapper search>
                <Header src={Image} />
                <SearchContainer>
                    <Container.Dropdown>
                        <Dropdown
                            top
                            arrow
                            select
                            size='large'
                            key='basic-4'
                            options={commonOptions4}
                        />
                    </Container.Dropdown>




                    {header.map((value) => {
                        return (
                            <Wrapper key={value.id}>
                                <Search onChange={onChange} onSubmit={onSearch} type='search' placeholder='Search Products, categories ...' />
                                <Icon.SearchIcon onClick={onSearch} />
                            </Wrapper>
                        )
                    })}
                </SearchContainer>

                <Wrapper>
                    <Icon.UserIcon />
                    <Wrapper>
                        <Update>4</Update>
                        <Icon.CartIcon />
                    </Wrapper>
                </Wrapper>
            </NavWrapper>
        </Container>
    )

};